import axios from 'axios';
import { sessaoEncerrada } from './sessao';

const api = axios.create({
  // Usa REACT_APP_API_URL se definido; caso contrário usa caminho relativo
  // (o Nginx do container encaminha /api/* para o backend automaticamente)
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 10000
});

// Interceptor de requisição
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Interceptor de resposta
api.interceptors.response.use(
  response => response,
  error => {
    // Onda 95: token vencido devolve 403, não 401 — ver services/sessao.js. A
    // tentativa de login fica de fora: senha errada é 401 e a tela de login
    // precisa mostrar a mensagem, não recarregar a si mesma.
    const ehLogin = String(error.config?.url || '').includes('/api/auth/login');
    if (!ehLogin && sessaoEncerrada(error)) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
